// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.sidebar-btn {
  display: flex;
  justify-content: flex-end;
  margin: 10px auto;
  gap: 10px;
}

/* La barre de périmètre a sa propre bande centrée au-dessus : cette ligne ne porte plus que les
   actions, qui restent ferrées à droite. */
.flexbox-panel {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: end;
  align-content: center;
}

.flexbox-item {
  flex: 0 1 auto;
}

.flex-item:nth-child(1) {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: auto;
}

.flex-item:nth-child(2) {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: auto;
}

.field {
  display: flex;
  flex-direction: column;
  width: -moz-fit-content;
  width: fit-content;
}

.field-group {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: stretch;
}

form {
  margin-bottom: 2rem;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndvcmtmbG93LW9sZC5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxnQkFBZ0I7QUFBaEI7RUFDSSxhQUFBO0VBQ0EseUJBQUE7RUFDQSxpQkFBQTtFQUNBLFNBQUE7QUFFSjs7QUFDQTsyQ0FBQTtBQUVBO0VBQ0ksYUFBQTtFQUNBLG1CQUFBO0VBQ0EsaUJBQUE7RUFDQSx5QkFBQTtFQUNBLGdCQUFBO0VBQ0EscUJBQUE7QUFFSjs7QUFDQTtFQUNJLGNBQUE7QUFFSjs7QUFDQTtFQUNJLFlBQUE7RUFDQSxjQUFBO0VBQ0EsZ0JBQUE7QUFFSjs7QUFDQTtFQUNJLFlBQUE7RUFDQSxjQUFBO0VBQ0EsZ0JBQUE7QUFFSjs7QUFDQTtFQUNJLGFBQUE7RUFDQSxzQkFBQTtFQUNBLHVCQUFBO0VBQUEsa0JBQUE7QUFFSjs7QUFDQTtFQUNJLGFBQUE7RUFDQSxtQkFBQTtFQUNBLGVBQUE7RUFDQSxTQUFBO0VBQ0Esb0JBQUE7QUFFSjs7QUFDQTtFQUNJLG1CQUFBO0FBRUoiLCJmaWxlIjoid29ya2Zsb3ctb2xkLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnNpZGViYXItYnRuIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGp1c3RpZnktY29udGVudDogZmxleC1lbmQ7XG4gICAgbWFyZ2luOiAxMHB4IGF1dG87XG4gICAgZ2FwOiAxMHB4O1xufVxuXG4vKiBMYSBiYXJyZSBkZSBww6lyaW3DqHRyZSBhIHNhIHByb3ByZSBiYW5kZSBjZW50csOpZSBhdS1kZXNzdXMgOiBjZXR0ZSBsaWduZSBuZSBwb3J0ZSBwbHVzIHF1ZSBsZXNcbiAgIGFjdGlvbnMsIHF1aSByZXN0ZW50IGZlcnLDqWVzIMOgIGRyb2l0ZS4gKi9cbi5mbGV4Ym94LXBhbmVsIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZGlyZWN0aW9uOiByb3c7XG4gICAgZmxleC13cmFwOiBub3dyYXA7XG4gICAganVzdGlmeS1jb250ZW50OiBmbGV4LWVuZDtcbiAgICBhbGlnbi1pdGVtczogZW5kO1xuICAgIGFsaWduLWNvbnRlbnQ6IGNlbnRlcjtcbn1cblxuLmZsZXhib3gtaXRlbSB7XG4gICAgZmxleDogMCAxIGF1dG87XG59XG5cbi5mbGV4LWl0ZW06bnRoLWNoaWxkKDEpIHtcbiAgICBmbGV4LWdyb3c6IDA7XG4gICAgZmxleC1zaHJpbms6IDE7XG4gICAgZmxleC1iYXNpczogYXV0bztcbn1cblxuLmZsZXgtaXRlbTpudGgtY2hpbGQoMikge1xuICAgIGZsZXgtZ3JvdzogMDtcbiAgICBmbGV4LXNocmluazogMTtcbiAgICBmbGV4LWJhc2lzOiBhdXRvO1xufVxuXG4uZmllbGQge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICB3aWR0aDogZml0LWNvbnRlbnQ7XG59XG5cbi5maWVsZC1ncm91cCB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4LWRpcmVjdGlvbjogcm93O1xuICAgIGZsZXgtd3JhcDogd3JhcDtcbiAgICBnYXA6IDFyZW07XG4gICAgYWxpZ24taXRlbXM6IHN0cmV0Y2g7XG59XG5cbmZvcm0ge1xuICAgIG1hcmdpbi1ib3R0b206IDJyZW07XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/pages/workflow-old/workflow-old.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,SAAA;AAEJ;;AACA;2CAAA;AAEA;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,qBAAA;AAEJ;;AACA;EACI,cAAA;AAEJ;;AACA;EACI,YAAA;EACA,cAAA;EACA,gBAAA;AAEJ;;AACA;EACI,YAAA;EACA,cAAA;EACA,gBAAA;AAEJ;;AACA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EAAA,kBAAA;AAEJ;;AACA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,oBAAA;AAEJ;;AACA;EACI,mBAAA;AAEJ;AAEA,o9DAAo9D","sourcesContent":[".sidebar-btn {\n    display: flex;\n    justify-content: flex-end;\n    margin: 10px auto;\n    gap: 10px;\n}\n\n/* La barre de périmètre a sa propre bande centrée au-dessus : cette ligne ne porte plus que les\n   actions, qui restent ferrées à droite. */\n.flexbox-panel {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    justify-content: flex-end;\n    align-items: end;\n    align-content: center;\n}\n\n.flexbox-item {\n    flex: 0 1 auto;\n}\n\n.flex-item:nth-child(1) {\n    flex-grow: 0;\n    flex-shrink: 1;\n    flex-basis: auto;\n}\n\n.flex-item:nth-child(2) {\n    flex-grow: 0;\n    flex-shrink: 1;\n    flex-basis: auto;\n}\n\n.field {\n    display: flex;\n    flex-direction: column;\n    width: fit-content;\n}\n\n.field-group {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 1rem;\n    align-items: stretch;\n}\n\nform {\n    margin-bottom: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
